import { NicheForm } from "components/popups/NicheForm";
import { Popup } from "components/popups/Popup";
import { INicheForm, IPrefOption, NicheFields, NicheFieldsNames } from "components/popups/NicheForm/NicheForm";
import "./EditNichePopup.scss";

interface IEditNichePopupProps {
  isOpen: boolean;
  nicheFields: { [key in NicheFieldsNames]: NicheFields };
  preview: string | null;
  onSubmit: (data: INicheForm) => void;
  onClose: () => void;
  banner?: string | null;
  avatarTicketId: string | null;
  bannerTicketId: string | null;
  handleAvatarTicketId: (ticketId: string) => void;
  handleBannerTicketId: (ticketId: string) => void;
  onSetPreferences: (prefs: IPrefOption[]) => void;
  onTagsChange: (tag: string[]) => void;
  tags: string[];
  prefOptions: IPrefOption[];
}

export const EditNichePopup: React.FC<IEditNichePopupProps> = (props) => {
  const {
    isOpen,
    onSubmit,
    onClose,
    nicheFields,
    preview,
    banner,
    avatarTicketId,
    bannerTicketId,
    handleAvatarTicketId,
    handleBannerTicketId,
    onSetPreferences,
    onTagsChange,
    tags,
    prefOptions
  } = props;

  return (
    <Popup
      isOpen={isOpen}
      onClose={onClose}
      popupClass="EditNichePopup"
      disableBackdropClose
    >
      <NicheForm
        preview={preview}
        fields={nicheFields}
        onSubmit={onSubmit}
        btnTitle="Save"
        banner={banner}
        handleAvatarTicketId={handleAvatarTicketId}
        handleBannerTicketId={handleBannerTicketId}
        onSetPreferences={onSetPreferences}
        onTagsChange={onTagsChange}
        tags={tags}
        avatarTicketId={avatarTicketId}
        bannerTicketId={bannerTicketId}
        prefOptions={prefOptions}
      />
    </Popup>
  );
};
